/* jshint multistr: true */

'use strict';

var Reflux   = require('reflux'),
    defaults = require('superagent-defaults'),
    Promise  = require('bluebird'),
    utils     = require('js/shared/utils/utils.js'),
    request  = require('superagent-promise');

var request = defaults(request);

request.set('X-Requested-With', 'XMLHttpRequest')
       .type('application/json')
       .accept('application/json');

var Actions = Reflux.createActions({

    loadNothing: {},

    // called when initially loading any stores
    loadApplication: { asyncResult: true, children: ['progressed'] },
    __loadUser: { asyncResult: true, children: ['progressed'] },
    __loadClaim: { asyncResult: true, children: ['progressed'] },
    __loadTeam: { asyncResult: true, children: ['progressed'] },
});

Actions.loadStore = function (store) {
    var dispatch = {
        '/v1/application': Actions.loadApplication,
        '/v1/search/claims?pipeline=1': Actions.__loadClaim,
        '/v1/users/me': Actions.__loadUser,
        'NONE': Actions.loadNothing
    };

    if (typeof store.endpoint === 'undefined')
        throw Error('You need to define an endpoint capable of refreshing \
                     your store.');

    if (!(store.endpoint in dispatch))
        throw Error('You need to specify a store-loading action \
                     in `js/shared/actions/store-actions.js`.');

    dispatch[store.endpoint]();
};

/**
 * Grabs the initial data for a page. Every store has an `endpoint` attribute
 * which is an endpoint that returns, in JSON, the contents of the store (refreshes
 * the store entirely). Each store has an `onLoadPage` listener which listens
 * for this action to be dispatched and updates the store.
 *
 * NOTE:
 *     This is the ONE place we currently break the Flux data flow pattern.
 *     (this action is asking for data from a store it was passed)
 *
 * WHY?
 *     Single page app optimized data retrieving from the server.
 *
 */
Actions.loadApplication.listen(function (token) {
    if (token === undefined) {
        token = utils.getParameterByName('token');
    }

    this.promise(new Promise(function (resolve, reject) {

        var loadedPromises = {};

        var completeIfReady = function() {
            if (Object.keys(loadedPromises).length === 3) {
                resolve([loadedPromises.user, loadedPromises.claim, loadedPromises.team]);
            }
        };

        Actions.__loadUser({
            token: token,
        }).then(function (resp) {
            if (resp.body.success === false) {
                reject([resp]);
                return;
            }
            else {
                loadedPromises.user = resp;
                completeIfReady();
            }
        }).catch(function(error) {
            reject([error]);
        });

        Actions.__loadClaim({
            token: token,
        }).then(function (resp) {
            if (resp.body.success === false) {
                reject([resp]);
                return;
            }
            else {
                loadedPromises.claim = resp;
                completeIfReady();
            }
        });

        Actions.__loadTeam({
            token: token,
        }).then(function (resp) {
            if (resp.body.success === false) {
                reject([resp]);
            } else {
                loadedPromises.team = resp;
                completeIfReady();
            }
        });
    }));
});

Actions.__loadUser.listen(function (options) {
    if (options === undefined)
        options = {};
    if (options.token === undefined)
        options.token = utils.getParameterByName("token");

    this.promise(request.get('https://hackerapi.com/v1/users/me?token=' + options.token).end());
});

Actions.__loadClaim.listen(function (options) {
    if (options === undefined)
        options = {};
    if (options.token === undefined)
        options.token = utils.getParameterByName("token");

    this.promise(request.get('https://hackerapi.com/v1/search/claims?pipeline=1&token=' + options.token).end());
});

Actions.__loadTeam.listen(function (options) {
    if (options === undefined)
        options = {};
    if (options.token === undefined)
        options.token = utils.getParameterByName("token");

    this.promise(request.get('https://hackerapi.com/v1/search/teams?token=' + options.token).end());
});

module.exports = Actions;



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/actions/store-actions.js
 ** module id = 248
 ** module chunks = 0 1 6 7 8 9
 **/